
import extend from '@/utils/vuex-extend';
import { table } from '@/vuex-extend';
import { wait } from '@/utils/wait';
import moment from 'moment';
import {fetchList, getAllDepotList, getAllAdminList, deliverOrderExport} from '@/api/sms/arrival-order';

const commonFetchList = async (state, dispatch, payload, cb) => {
	await wait(dispatch, 'sms.arrival-order.list', async function() {
		const { searchForm } = state;
		await dispatch('getData', {
			caller: cb,
			options: {
				...searchForm,
				materialType: searchForm.materialType === '' ? null : searchForm.materialType,
				time: null,
				gmtStart: searchForm.time && searchForm.time[0] && Math.round(moment(searchForm.time[0]).startOf('day').valueOf() / 1000),
				gmtEnd: searchForm.time && searchForm.time[1] && Math.round(moment(searchForm.time[1]).endOf('day').valueOf() / 1000),
				...payload,
			}
		});
	})
}

export default extend(table, {
    namespaced: true,
    state: {
		depotList: [],
        searchForm: {},
		adminList: []
    },
    actions: {
        async getList({ state, dispatch }, payload) {
			await commonFetchList(state, dispatch, payload, fetchList)
		},
		async getAllDepotList({ state, dispatch, commit }, payload) {
			await wait(dispatch, 'sms.arrival-order.all-depot', async function() {
				const response = await getAllDepotList();
				if (response.data) {
					commit('save', {
						depotList: response.data.list
					})
				}
            })
		},
		async getAllAdminList({ state, dispatch, commit }, payload) {
			await wait(dispatch, 'scm.error-order.all-admin', async function() {
				const response = await getAllAdminList();
				if (response.data) {
					commit('save', {
						adminList: response.data.adminList
					})
				}
			})
		},
		async deliverOrderExport({ state, dispatch }, payload) {
        	await commonFetchList(state, dispatch, payload, deliverOrderExport)
		}
    }
})



// WEBPACK FOOTER //
// ./src/store/modules/sms/arrival-order/list.js